<template>
  <div class="pc-game-container">
    <wiki-home-top />
    <fixed-share :isShowDetailBox="isShowDetailBox" />
    <div id="wikiMainBox" class="wiki-main-box">
      <!-- 右侧悬浮按钮 -->
      <right-banner :gameInfo="gameInfo" :linkInfos="modelsList[2]" />
      <div class="wiki-home">
        <!-- 左侧区域 -->
        <div
          :class="['left-container', isExpand ? '' : 'fill-container']"
          id="leftScroll"
          :style="{ marginRight: isExpand ? 0 : '30px' }"
          @wheel.stop="leftBoxScroll"
        >
          <!-- banner轮播 -->
          <banner-container
            v-if="isExpand && calcBannerList.length"
            :isAutoWidth="true"
            :list="calcBannerList"
            from="game"
          />
          <banner-expand
            v-if="!isExpand && calcBannerList.length"
            :isAutoWidth="true"
            :list="calcBannerList"
            from="game"
          />
          <!-- wiki信息 -->
          <info-card :gameInfo="currentGameInfo" style="margin-bottom: 20px;" />
          <!-- 游戏视频 -->
          <div class="model-item">
            <div class="header">
              <div class="title">游戏视频</div>
            </div>
            <el-row v-if="currentGameInfo.video && currentGameInfo.video.length" :gutter="15">
              <el-col
                v-for="(data, index) in currentGameInfo.video"
                :key="index"
                :span="isExpand ? 8 : 4"
                class="col-video-item"
              >
                <div class="video-box" @click="handleCurrentVideo(data)">
                  <div class="top-bg">
                    <img
                      v-if="data.cover && data.cover.host && data.cover.url"
                      v-lazy="handleImgSize(`${data.cover.host}${data.cover.url}`, 'icon')"
                      class="bg-img"
                      alt=""
                    />
                    <div class="bg-bottom">
                      <span class="text">
                        <i class="wiki-icon wiki-game-video"></i>
                        <span>{{ data.play_num }}</span>
                      </span>
                      <span class="text">
                        {{ calcDuration(data.duration) }}
                      </span>
                    </div>
                  </div>
                  <div class="name">
                    {{ data.title }}
                  </div>
                  <div class="video-footer">
                    <span>{{ data.author }}</span>
                    <span>{{ data.created_at | dateFormat("YYYY-MM-DD") }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 游戏情报 -->
          <div class="model-item">
            <div class="header">
              <div class="title">游戏情报</div>
            </div>
            <el-row v-if="currentGameInfo.news_list && currentGameInfo.news_list.length" :gutter="isExpand ? 0 : 30">
              <el-col
                v-for="(news, index) in currentGameInfo.news_list"
                :key="index"
                :span="isExpand ? 24 : 12"
                class="col-item"
              >
                <div class="news-box" @click="handleCurrentNews(news)">
                  <div class="pic">
                    <img v-if="news.thumb" v-lazy="handleImgSize(news.thumb.split(',')[0], 'icon')" alt="" />
                  </div>
                  <div class="content">
                    <div class="title">
                      {{ news.title }}
                    </div>
                    <div class="info">
                      {{ news.summary }}
                    </div>
                    <div class="footer">
                      <span class="mR10">{{ news.created_at | dateFormat("YYYY年MM月DD日") }}</span>
                      <span class="view-box">
                        <i class="wiki-icon wiki-view-number"></i>
                        <span>{{ news.view_count }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 左右切换按钮 -->
        <div :class="['split-line', isExpand ? '' : 'un-expand-line']">
          <div class="toggle" @click="isExpand = !isExpand">
            <i v-if="isExpand" class="el-icon-caret-right"></i>
            <i v-else class="el-icon-caret-left"></i>
          </div>
        </div>
        <!-- 右侧区域 -->
        <pc-right-container
          id="rightScroll"
          ref="rightScrollRef"
          class="pc-right-container"
          @rightBoxScroll="rightBoxScroll"
          :isExpand="isExpand"
          :lang="lang"
          :isShowDetailBox="isShowDetailBox"
          :modelsList="modelsList"
          :tagList="tagList"
          :lastUpdateList="lastUpdateList"
          @onSendBoxOk="onSendBoxOk"
        />
      </div>
    </div>
    <el-dialog :visible.sync="videoModalVisible" width="900px" center @closed="currentVideoUrl = ''">
      <template v-if="currentVideoUrl">
        <video width="100%" autoplay controls :src="currentVideoUrl"></video>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import PcRightContainer from "./components/pcRightContainer";
import BannerContainer from "@/views/wiki/components/bannerContainer";
import BannerExpand from "@/views/wiki/components/bannerExpand";
import WikiHomeTop from "@/views/wiki/components/wikiHomeTop";
import FixedShare from "@/views/wiki/components/fixedShare";
import InfoCard from "./components/infoCard";
import RightBanner from "@/views/wiki/components/rightBanner";
// apis
import { apiContentEdit } from "@/api/contentApi";
import { apiWikiIndex, apiWikiEntryLastUpdateList } from "@/api/wikiApi";
import { apiWikiGameInfo, apiGameVideoAddPlayNum } from "@/api/gameApi";
// i18n
import { getLang } from "@/i18n";
// plugins
import eventBus from "@/plugins/eventBus";
import { calcDuration } from "@/plugins/util";
// mixins
import calcMixin from "@/mixins/calcMixin";
import positionMixin from "@/mixins/positionMixin";
import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";

function getTagList($vm) {
  // console.log($vm);
  return {
    0: {
      color: "red",
      text: $vm.$t("notice_tags.tag3")
    },
    1: {
      color: "red",
      text: $vm.$t("notice_tags.tag3")
    },
    2: {
      color: "orange",
      text: $vm.$t("notice_tags.tag3")
    },
    3: {
      color: "blue",
      text: $vm.$t("notice_tags.tag2")
    },
    4: {
      color: "red",
      text: $vm.$t("notice_tags.tag1")
    }
  };
}

function handleModelList(list) {
  let modelsList = {
    1: {
      list: [],
      module: {}
    },
    2: {
      list: [],
      module: {}
    },
    3: {
      list: [],
      module: {}
    },
    4: {
      list: [],
      module: {}
    },
    5: {
      list: [],
      module: {}
    },
    6: {
      list: [],
      module: {}
    },
    7: {
      list: [],
      module: {}
    },
    8: {
      list: [],
      module: {}
    },
    9: {
      list: [],
      module: {}
    }
  };
  // console.log(list);
  if (list) {
    list.forEach(item => {
      if (item.module.type == 6) {
        item.list &&
          item.list.forEach(item => {
            item.tag = item.tag || "0";
          });
      }
      modelsList[item.module.type] = item;
    });
  }
  return modelsList;
}
export default {
  name: "wikiGame",
  mixins: [calcMixin, positionMixin, mergeAsyncDataMixin],
  props: {},
  model: {},
  components: {
    WikiHomeTop,
    BannerContainer,
    BannerExpand,
    FixedShare,
    PcRightContainer,
    InfoCard,
    RightBanner
  },
  data() {
    return {
      modelsList: handleModelList(),
      isSSRGetData: false,
      searchName: "",
      videoModalVisible: false,
      lang: "zh-cn",
      isExpand: true,
      isShowDetailBox: false,
      // 更多wiki数据
      moreWikiData: {},
      isMoreWikiShow: false,
      currentGameInfo: {
        ext: { desc: "", screen_shot: [] },
        game: { icon: "", name: "", alias: "" },
        news_list: [],
        video: []
      },
      currentVideoUrl: "",
      lastUpdateList: []
    };
  },
  async asyncData({ store, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      // TDK设置
      const gameInfo = store.getters.gameInfo;
      ssrContext.title = `${gameInfo.name}游戏介绍_${gameInfo.name}好玩吗_${gameInfo.name}wiki|GameKee`;
      ssrContext.keywords = `${gameInfo.name}好玩吗,${gameInfo.name}游戏介绍`;
      ssrContext.description = `${gameInfo.name}游戏介绍专栏为您详细介绍${gameInfo.name}的基础玩法和${gameInfo.name}相关新闻活动，想知道${gameInfo.name}好玩吗看这些就够了！`;
      // 数据预取
      const res = await Promise.all([
        $apis.apiWikiIndex(),
        $apis.apiWikiGameInfo(),
        $apis.apiWikiEntryLastUpdateList()
      ]);
      let modelsList = handleModelList();
      const { code: wikiResCode, data: wikiResData } = res[0];
      if (wikiResCode == 0) {
        modelsList = handleModelList(wikiResData);
      }
      let currentGameInfo = {
        ext: { desc: "", screen_shot: [] },
        game: { icon: "", name: "", alias: "" },
        news_list: [],
        video: []
      };
      const { code: gameResCode, data: gameResData } = res[1];
      if (gameResCode == 0) {
        currentGameInfo = gameResData;
      }

      const { code: lastUpdateResCode, data: lastUpdateResData } = res[2];
      let lastUpdateList = [];
      if (lastUpdateResCode == 0) {
        lastUpdateList = lastUpdateResData;
      }

      console.log("asyncData end");
      return {
        modelsList,
        lastUpdateList,
        currentGameInfo,
        isSSRGetData: true
      };
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapGetters(["gameInfo"]),
    tagList() {
      return getTagList(this);
    },
    calcBannerList() {
      const list = this.currentGameInfo.ext && this.currentGameInfo.ext.screen_shot;
      if (list && list.length) {
        const res = list
          .map((item, index) => {
            return {
              id: index,
              thumb: item.url
            };
          })
          .slice(0, 10);
        return res;
      }
      return [];
    }
  },
  created() {},
  beforeMount() {
    this.lang = getLang();
  },
  mounted() {
    // 判断服务端渲染获取数据
    if (!this.isSSRGetData) {
      this.getIndexData();
      this.getGameInfo();
      this.getLastUpdateList();
    }
    eventBus.$on("setDetailBoxVisible", visible => {
      this.isShowDetailBox = visible;
      // 当收到右侧详情框隐藏的时候，将右侧详情滚动条设为0，并返回wiki默认右侧滚动条位置
      if (!visible) {
        this.rightDetailScrollTop = 0;
        this.setScrollTop("rightScroll", this.rightCurrentScrollTop);
      }
    });
    eventBus.$on("setExpand", visible => {
      this.isExpand = visible;
    });
    eventBus.$on("setMoreWiki", async data => {
      this.isMoreWikiShow = true;
      this.moreWikiData = data;
      await this.$nextTick();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  },
  updated() {},
  beforeDestroy() {
    eventBus.$off("setDetailBoxVisible");
    eventBus.$off("setExpand");
    eventBus.$off("setMoreWiki");
  },
  destroyed() {},
  methods: {
    calcDuration,
    bgStyle(filed, type = "cover") {
      let config = this.gameInfo.Config || {};
      if (config[filed]) {
        return {
          background: `url(${config[filed]}) no-repeat left center`,
          backgroundSize: type
        };
      } else {
        return "";
      }
    },
    // ModuleTypeSlider     = 1 //轮播图模块
    // ModuleTypeFriendLink = 2 //友情链接
    // ModuleTypeAdminList  = 3 //管理员列表
    // ModuleTypeHotEntry   = 4 //热门词条
    // ModuleTypeActivity   = 5 //活动周历
    // ModuleTypeNotice     = 6 //公告
    // ModuleTypeBbs        = 7 //帖子
    getIndexData() {
      apiWikiIndex().then(({ data }) => {
        // this.handleModelList(data);
        this.modelsList = handleModelList(data);
      });
    },
    async getLastUpdateList() {
      try {
        const { code, data } = await apiWikiEntryLastUpdateList();
        if (code == 0) {
          this.lastUpdateList = data || [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    goSearch() {
      let { searchName } = this;
      if (searchName) {
        this.searchName = "";
        this.$router.push(`${this.gameInfo.alias}/list?kw=${searchName}`);
      }
    },
    goEdit() {
      if (!this.isLoginShow("")) return false;
      if (!this.isAuthRealName("")) return false;
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    },
    handleItemBackWiki() {
      this.isMoreWikiShow = false;
      this.moreWikiData = {};
    },
    onSendBoxOk(data) {
      if (!this.isLoginShow("")) return false;
      if (!this.isAuthRealName("")) return false;
      console.log(data);
      const { text, thumb, contentJson } = data;

      let params = {
        editor_type: 1, // 新编辑器
        content_json: JSON.stringify(contentJson),
        summary: text.slice(0, 100),
        title: text.slice(0, 20),
        type: 4,
        thumb: thumb.join(",")
      };
      apiContentEdit(params).then(res => {
        this.$message.success("发布成功");
        params = {
          ...params,
          game: this.gameInfo,
          game_alias: this.gameInfo.alias,
          game_id: this.gameInfo.id,
          like_count: 0,
          id: res.data.id,
          comment_count: 0,
          view_count: 0,
          user: this.loginUser,
          updated_at: 0
        };
        const insertIndex = this.modelsList[7].list.findLastIndex(item => {
          return item.is_top;
        });
        this.modelsList[7].list.splice(insertIndex + 1, 0, params);
        this.$refs.rightScrollRef.clearBox();
      });
    },
    getGameInfo() {
      apiWikiGameInfo().then(res => {
        this.currentGameInfo = res.data || {
          ext: { desc: "", screen_shot: [] },
          game: { icon: "", name: "", alias: "" },
          news_list: [],
          video: []
        };
      });
    },
    handleCurrentNews(data) {
      this.isExpand = true;
      this.isShowDetailBox = true;
      eventBus.$emit("getDetail", data.id);
    },
    // 点击当前视频
    handleCurrentVideo(data) {
      if (!data.video_url) {
        return;
      }
      this.currentVideoUrl = data.video_url;
      this.videoModalVisible = true;
      apiGameVideoAddPlayNum({ id: data.id }).then(res => {
        data.play_num = (data.play_num || 0) + 1;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.pc-game-container {
  width: 100%;
  // height: 100%;
  // background: fade(#fff, 76%);
  // margin-top: 16px;
  // padding: 0 12px 16px 12px;
  position: relative;
  box-sizing: border-box;
  // overflow: hidden;
  .wiki-main-box {
    position: relative;
    width: 100%;
    margin-top: 12px;
    padding: 12px 0;
    border-radius: 12px;
    background: rgba(174, 181, 203, 0.45);
  }
}

.wiki-home {
  position: relative;
  width: 100%;
  // min-height: 500px;
  padding: 0 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;

  .left-container {
    flex: 0 0 auto;
    width: calc(50% - 8px);
    height: calc(100vh - 108px);
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    // transition: all ease 0.3s;
    background-color: #fff;
    overflow-y: auto;
    &.fill-container {
      width: calc(100% - 16px);
    }
    .more-wiki-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      .icon-item {
        width: 28px;
        height: 28px;
        border-radius: 6px;
        background-color: #eee;
        cursor: pointer;
        line-height: 28px;
        text-align: center;
        color: #000;
        font-size: 18px;
        font-weight: bold;
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
    .model-item {
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        .title {
          color: #333;
          font-size: 16px;
          font-weight: 600;
        }
      }
      .col-item {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .col-video-item {
        margin-bottom: 15px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .video-box {
        width: 100%;
        cursor: pointer;
        .top-bg {
          position: relative;
          width: 100%;
          height: 132px;
          border-radius: 4px;
          .bg-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }
          .bg-bottom {
            display: flex;
            position: absolute;
            justify-content: space-between;
            align-items: flex-end;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 53px;
            padding: 0 8px 6px 8px;
            box-sizing: border-box;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
            .text {
              display: flex;
              align-items: center;
              color: #fff;
              font-size: 14px;
              i {
                margin-right: 4px;
              }
            }
          }
        }
        .name {
          .ellipsis;
          margin-top: 8px;
          // overflow: hidden;
          // display: -webkit-box;
          // -webkit-box-orient: vertical;
          // -webkit-line-clamp: 2;
          color: #171717;
          line-height: 20px;
          font-size: 14px;
        }
        .video-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 8px;
          color: #999;
          font-size: 12px;
        }
      }
      .news-box {
        display: flex;
        width: 100%;
        cursor: pointer;
        .pic {
          flex: 0 0 auto;
          width: 118px;
          height: 90px;
          margin-right: 16px;
          background-color: #e3e6ee;
          border-radius: 4px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
          }
        }
        .content {
          flex: 1;
          padding-right: 5px;
          overflow: hidden;
          .title {
            .ellipsis;
            margin-bottom: 4px;
            color: #171717;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
          }
          .info {
            margin-bottom: 12px;
            color: #666;
            font-size: 12px;
            line-height: 17px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .footer {
            display: flex;
            align-items: center;
            color: #999;
            font-size: 12px;
            .view-box {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
  .pc-right-container {
    height: calc(100vh - 108px);
  }

  .pc-right-container,
  .left-container {
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 6px; /*定义纵向滚动条宽度*/
      height: 6px; /*定义横向滚动条高度*/
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条内部滑块*/
      border-radius: 6px;
      background-color: rgba(144, 147, 153, 0.3);
      transition: background-color 0.3s;
    }

    &::-webkit-scrollbar-thumb:hover {
      /*鼠标悬停滚动条内部滑块*/
      background: #bbb;
    }

    &::-webkit-scrollbar-track {
      /*滚动条内部轨道*/
      background: #ededed;
    }
  }

  /deep/ .home-model-container {
    margin-bottom: 28px;

    .model-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      margin-bottom: 10px;
      // background: #404040;

      .title {
        font-size: 16px;
        font-weight: 600;
        color: #222222;
        // border-left: 3px solid #F7CE7A;
        // margin-left: 5px;
        // padding-left: 11px;
        line-height: 22px;
      }

      .right-wrapper {
        .edit-btn {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: @button-bg-color;
          i {
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .split-line {
    position: relative;
    width: 6px;
    margin: 0 5px;
    background-color: #29c0f7;
    border-radius: 6px;
    opacity: 0.3;
    transition: all ease 0.1s;
    &:hover {
      opacity: 1;
    }
    .toggle {
      position: fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 50%;
      right: 50%;
      width: 24px;
      height: 100px;
      background: #d9f5ff;
      border: 1px solid #29c0f7;
      transform: translateX(50%);
      cursor: pointer;
      i {
        font-size: 22px;
        font-weight: bold;
        color: #29c0f7;
      }
    }
    &.un-expand-line {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 20px;
      margin: 0 !important;
      background-color: #fff;
      border-radius: 8px 0px 0px 8px;
      opacity: 1;
      .toggle {
        right: calc((100% - 1380px) / 2 + 8px);
        transform: translateX(-50%);
        border-right: none;
      }
    }
  }
}
.game-detail-box {
  border-top: 6px solid #404040;

  .game-detail-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin-top: 8px;
  }

  .game-detail {
    margin: 8px 12px;

    .desc {
      font-size: 13px;
      color: #424242;
      line-height: 20px;
      overflow: hidden;
    }
  }
}

.sq-btn {
  color: #292929;
  cursor: pointer;
}

.entry-new-group {
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & + .item {
      margin-top: 10px;
    }

    &:hover {
      .title {
        text-decoration: underline;
      }
    }

    > div {
      display: flex;
      align-items: center;
    }

    & + a {
      margin-top: 14px;
    }

    .date {
      color: #575757;
      font-size: 12px;
    }

    .title {
      .ellipsis;
      display: block;
      color: #424242;
      font-size: 13px;
      width: 220px;
      line-height: 20px;
    }

    .user {
      .ellipsis;
      width: 70px;
      color: @text-gray;
      font-size: 12px;
      margin-left: 20px;
      text-align: right;
    }
  }
}

.article-nav-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid @border-basic;
  margin-bottom: 20px;

  .nav {
    display: flex;
    align-items: center;

    div + div {
      margin-left: 20px;
    }

    div {
      color: #8b8b8b;
      padding: 4px 0;
      cursor: pointer;

      &.active {
        color: @basic;
      }
    }
  }

  .more-btn {
    color: #575757;
    transition: 0.3s;
    font-size: 12px;
    cursor: pointer;

    &:hover {
      color: @basic;
    }
  }
}
</style>
<style lang="less">
.link-btn {
  width: 100%;
  height: 56px;
  background: url("~@/assets/images/right-link-btn-default.png") no-repeat center;
  background-size: 100% 100%;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 12px;
  font-size: 18px;
  font-weight: bold;
  color: #404040;
  cursor: pointer;

  &.custom-img {
    color: #fff;
    text-shadow: 0 0 2px #999;
  }
}
</style>
